import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";

export const SkanId2VisaMobile = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/vxlab-onboarding_success-visa-mobile${currentParams}`);
  };

  const styles = {
    telefono: {
      fontFamily: "Open Sans, sans-serif",
      marginTop: "30px",
      backgroundColor: "#f1f1f1",
      display: "flex",
      borderRadius: "50px",
      border: "15px solid #000000",
      flexDirection: "row",
      justifyContent: "center",
      width: "100%",
    },
    container: {
      display: "flex",
      alignItems: "center",
      margin: "16px 0 8px 0",
      padding: "16px",
      height: "100%",
      boxSizing: "border-box",

    },
    arrow: {
      fontSize: "26px",
      marginLeft: "8px",
    },
    containerPhone: {
      width: "100%",
      background: "#263238",
      margin: "0 auto",
      fontFamily: "sans-serif",
      padding: "20px",
    },
    description: {
      fontSize: "15px",
      color: "#333",
      marginBottom: "20px",
      lineHeight: "1.5",
    },
    label: {
      display: "block",
      fontSize: "14px",
      fontWeight: "600",
      marginBottom: "12px",
      color: "#111",
    },
    topSection: {
      backgroundColor: "#263238",
      height: "400px",
      position: "relative",
      padding: "20px",
      display: "flex",
      justifyContent: "center",
    },
    closeBtn: {
      position: "absolute",
      top: -10,
      right: -15,
      background: "none",
      color: "#fff",
      border: "none",
      fontSize: "20px",
      cursor: "pointer",
    },
    imageWrapper: {
      borderRadius: "8px",
      padding: "4px",
    },
    image: {
      width: "260px",
      borderRadius: "4px",
    },
    bottomSection: {
      marginTop: "40px",
      textAlign: "center",
      padding: "16px",
    },
    stepper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    stepActive: {
      backgroundColor: colors.primario,
      color: "#fff",
      width: "28px",
      height: "28px",
      borderRadius: "50%",
      lineHeight: "28px",
      fontWeight: "bold",
    },
    stepInactive: {
      backgroundColor: "#e5e7eb",
      color: "#6b7280",
      width: "28px",
      height: "28px",
      borderRadius: "50%",
      lineHeight: "28px",
      fontWeight: "bold",
    },
    line: {
      height: "2px",
      width: "40px",
      backgroundColor: "#d1d5db",
      margin: "0 8px",
    },
    labels: {
      display: "flex",
      justifyContent: "center",
      gap: "50px",
      marginTop: "8px",
    },
    labelActive: {
      fontSize: "14px",
      color: "#111827",
      fontWeight: "bold",
    },
    labelInactive: {
      fontSize: "14px",
      color: "#9ca3af",
    },
    lines: {
      display: "flex",
      flexDirection: "column",
      marginRight: "8px",
    },
    lineBlue: {
      width: "30px",
      height: "6px",
      backgroundColor: colors.primario,
      marginBottom: "4px",
    },
    lineYellow: {
      width: "30px",
      height: "6px",
      backgroundColor: colors.secundario,
    },
    containerStep: {
      display: "flex",
      alignItems: "baseline",
      fontFamily: "sans-serif",
    },
    current: {
      color: colors.primario,
      fontSize: "40px",
      fontWeight: "bold",
    },
    separator: {
      margin: "0 2px",
      color: "#959699",
      fontSize: "18px",
    },
    total: {
      color: "#959699",
      fontSize: "18px",
    },
    page: {
      fontFamily: "Open Sans, sans-serif",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "30px",
      position: "relative",
      backgroundColor: "#ffffff",
      width: "375px",
      height: "812px",
      overflow: "hidden",
      boxShadow: "0 0 20px rgba(0,0,0,0.1)",
    },

    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "16px",
      height: "160px",
      width: "90%",
      borderBottom: "1px solid #E7E7E7",
    },
    title: {
      fontSize: "18px",
      marginBottom: "20px",
      color: "#333",
    },
    checkboxContainer: {
      display: "flex",
      alignItems: "flex-start",
      gap: "10px",
      width: "90%",
      marginBottom: "40px",
    },
    checkbox: {
      marginTop: "4px",
      transform: "scale(1.2)",
      accentColor: "#0052cc",
    },

    button: {
      width: "90%",
      padding: "12px",
      height: "54px",
      backgroundColor: colors.primario,
      color: "#fff",
      fontSize: "16px",
      border: "none",
      borderRadius: "6px",
      cursor: "pointer",
      position: "absolute",
      bottom: 16,
    },
  };

  return (
    <div style={styles.telefono}>
      <div style={styles.page}>
        <div style={styles.header}>
          <div style={{display: "flex", gap: 12}}>
            {colors.url_logo !== "" ? (
                <img className="inicio-de-sesion-de-2" src={colors.url_logo}
                     style={{height: 70, maxWidth: 120, objectFit:'contain'}}/>) : (<></>)}
          </div>
          <div style={styles.containerStep}>
            <span style={styles.current}>04</span>
            <span style={styles.separator}> / </span>
            <span style={styles.total}>06</span>
          </div>
        </div>
        <div
            style={{
              ...styles.container,
              width: "100%",
              flexDirection: "column",
              justifyContent: "initial",
              alignItems: "center",
            }}
        >
          <div style={styles.containerPhone}>
            <div style={styles.topSection}>
              <button style={styles.closeBtn}>✕</button>
              <div style={styles.imageWrapper}>
                <img
                    src="/img/skanid.png"
                    alt="Document preview"
                  style={styles.image}
                />
              </div>
            </div>
          </div>
          <div style={styles.bottomSection}>
            <div style={styles.stepper}>
              <div style={styles.stepActive}>1</div>
              <div style={styles.line}></div>
              <div style={styles.stepInactive}>2</div>
            </div>
            <div style={styles.labels}>
              <span style={styles.labelActive}>Front</span>
              <span style={styles.labelInactive}>Back</span>
            </div>
          </div>
          <button onClick={handleButtonClick} style={styles.button}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};
